class CustomSlider extends HTMLElement {
    constructor() {
      super();
    }
	
	connectedCallback() {
        // Wait for Swiper to be available
        if (window.Swiper) {
            this.initializeSlider();
        } else {
            document.addEventListener('DOMContentLoaded', () => {
                this.initializeSlider();
            });
        }
    }

    initializeSlider() {
        const swiperElement = this.querySelector('.swiper');
        const swiperButtonNext = this.querySelector('.swiper-button-next');
        const swiperButtonPrev = this.querySelector('.swiper-button-prev');
        const swiperPagination = this.querySelector('.swiper-pagination');
        if (swiperElement) {
            new Swiper(swiperElement, {
                slidesPerView: 1.1, // Adjust to fit your needs
                spaceBetween: 16, // Adjust the spacing between slides
                freeMode: {
							enabled: true,
							momentum: true,
                },
                navigation: {
                    nextEl: swiperButtonNext,
                    prevEl: swiperButtonPrev,
                },
                pagination: {
                    el: swiperPagination,
                    clickable: true,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2.1,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 4.1,
                        spaceBetween: 24,
                    },
                },
            });
        }
    }
}


// Only define the custom element if it hasn't been defined yet
if (!customElements.get('custom-slider')) {
    customElements.define('custom-slider', CustomSlider);
}